import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {LOGIN_STATUS as loginStat } from '../../../utils/constant.utils';
class PageNotFound extends Component {
    render() {
        let logInStatus = sessionStorage.getItem('logInStatus');
        let homeUrl = logInStatus === loginStat.external ? '/external' 
            : logInStatus === loginStat.internal ? '/internal' : '/';
        return (
            <div className='page-not-found'>
                <h1>404</h1>
                <p>Page not found.</p>
                <Link to={homeUrl}>Go home.</Link>
            </div>
        );
    }
}
export default (PageNotFound);
